<template>
  <el-dialog
    title="New Opportunity"
    :visible.sync="isVisible"
    :close-on-click-modal="!isCreatingOpportunity"
    :close-on-press-escape="!isCreatingOpportunity"
    :show-close="!isCreatingOpportunity"
    width="70vw"
    top="2vh"
    @closed="$emit('destroy')"
  >
    <el-dialog
      width="30%"
      title="Notice"
      :visible.sync="isPromptingNewEvent"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
    >
      You are required to create an event for this opportunity

      <template #footer>
        <el-button
          type="primary"
          @click.native="createNewEvent"
        >
          OK
        </el-button>
      </template>
    </el-dialog>

    <OpportunityForm :opportunity="opportunity" />

    <template #footer>
      <el-button
        :disabled="isCreatingOpportunity"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isCreatingOpportunity"
        @click.native="createOpportunity"
      >
        Create Opportunity
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import OpportunityForm from '@/components/Application/Sales/Opportunities/Opportunity/Form'

export default {
  components: {
    OpportunityForm
  },
  props: {
    opportunity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isCreatingOpportunity: false,
      isPromptingNewEvent: false
    }
  },
  methods: {
    async createOpportunity () {
      this.isCreatingOpportunity = true

      try {
        await this.opportunity.create()

        this.$message.success('Successfully created Opportunity')

        this.isPromptingNewEvent = true
      } catch {
        this.$message.error('Failed to create new Opportunity')
      }

      this.isCreatingOpportunity = false
    },
    createNewEvent () {
      this.isPromptingNewEvent = false

      const newEvent = new this.$sdk.account_event()

      newEvent.account = this.opportunity.account

      this.$emit('new-event', newEvent)

      this.isVisible = false
    }
  }
}
</script>
